<template>
  <div v-if="isShowPage" class="collection">
    <div class="col-header">
      <!-- 导航 -->
      <van-nav-bar
        left-text
        :right-text="showTab==='sale'?sellProperty.clearText:showTab==='rent'?rentProperty.clearText:showTab==='estate'?estProperty.clearText:newProperty.clearText"
        left-arrow
        @click-left="onClickLeft"
        @click-right="onClear"
      />
      <!-- tab按钮 -->
      <div class="col-tab">
        <span :class="{'on':showTab==='sale'}" @click="showTab ='sale'">{{lang.esSale}}</span>
        <span :class="{'on':showTab==='rent'}" @click="showTab ='rent'">{{lang.rent}}</span>
        <span :class="{'on':showTab==='newestate'}" @click="showTab ='newestate'">{{lang.newSale}}</span>
        <span :class="{'on':showTab==='estate'}" @click="showTab ='estate'">{{lang.estate}}</span>
      </div>
    </div>
    <!-- tab切换列表 -->
    <div>
      <div class="none-record" v-if="showTab==='sale'?sellProperty.showNull:showTab==='rent'?rentProperty.showNull:showTab==='newestate'?newProperty.showNull:estProperty.showNull">
        <img src="//static.house730.com/m/images/none_col.png" :alt="lang.noInfo" class="none_col" />
        <p>{{lang.noInfo}}</p>
      </div>
      <div v-else>
        <!-- 售列表 -->
        <div v-if="showTab==='sale'">
          <van-list v-model="sellProperty.loading" :finished="sellProperty.finished" :loading-text="lang.loading" :finished-text="lang.noMore" @load="onload(sellProperty)">
            <historyList :houseList="sellProperty.list"></historyList>
          </van-list>
        </div>
        <!-- 租列表 -->
        <div v-if="showTab==='rent'">
          <van-list v-model="rentProperty.loading" :finished="rentProperty.finished" :loading-text="lang.loading" :finished-text="lang.noMore" @load="onload(rentProperty)">
            <historyList :houseList="rentProperty.list"></historyList>
          </van-list>
        </div>
        <!-- 新房列表 -->
        <div v-if="showTab==='newestate'">
          <van-list v-model="newProperty.loading" :finished="newProperty.finished" :loading-text="lang.loading" :finished-text="lang.noMore" @load="onload(newProperty)">
            <newList :houseList="newProperty.list" @cancelCollection="cancelCollection"></newList>
          </van-list>
        </div>
        <!-- 屋苑列表 -->
        <div v-if="showTab==='estate'">
          <van-list v-model="estProperty.loading" :finished="estProperty.finished" :loading-text="lang.loading" :finished-text="lang.noMore" @load="onload(estProperty)">
            <estList :houseList="estProperty.list" @cancelCollection="cancelCollection"></estList>
          </van-list>
        </div>
      </div>
    </div>
    <!-- 点击清除出现的蒙版 -->
    <van-dialog v-model="showClear" :title="lang.delColTit" show-cancel-button :confirmButtonText="lang.confirmButtonText" :cancelButtonText="lang.cancelButtonText" :overlay="false" :beforeClose="beforeClose"/>
    <div class="popup-clear" v-show="showClear"></div>
  </div>
</template>

<script>
// import { Toast } from 'vant';
import pub from '../../common/public';
import lang from './../../common/language/history';
import '../../common/css/common.scss';
import historyList from '../components/history-list';
import estList from '../components/est-list'
import newList from '../components/new-list';
export default {
  metaInfo: { title: lang.myFavourites },
  name: 'collection',
  data() {
    return {
      isShowPage: false,
      isPc: false,
      lang: lang,
      showTab: '',
      // 点击清除显示蒙版
      showClear: false,
      // 加载更多
      sellProperty:{
        list:[],
        clearText: '',
        loading: false,
        finished: false,
        pageIndex: 1,
        showNull: false,//是否展示空白
      },
      rentProperty:{
        list:[],
        clearText: '',
        loading: false,
        finished: false,
        pageIndex: 1,
        showNull: false,//是否展示空白
      },
      newProperty:{
        list:[],
        clearText: '',
        loading: false,
        finished: false,
        pageIndex: 1,
        showNull: false,//是否展示空白
      },
      estProperty:{
        list:[],
        clearText: '',
        loading: false,
        finished: false,
        pageIndex: 1,
        showNull: false,//是否展示空白
      },
      // estateButton: false,
    };
  },
  created() {
    this.isPc = !(document.body.clientWidth <= 750 || /mobi|android|iphone|blackberry|ipod|iemobile/i.test(navigator.userAgent.toLocaleLowerCase()))
    if (this.isPc) {
      if (pub.getLang() === 'zh-cn') {
        location.href = `${pub.config.pcPassport}zh-cn/fav/`;
      } else if (pub.getLang() === 'en-us') {
        location.href = `${pub.config.pcPassport}en-us/fav/`;
      } else {
        location.href = `${pub.config.pcPassport}fav/`;
      }
    } else {
      this.isShowPage = true;
    }
    // let estateB = JSON.parse(sessionStorage.getItem("estate_switch"));
    // if(estateB == 1){
    //   this.estateButton = !this.estateButton;
    // }else{
    //   this.estateButton = this.estateButton;
    // }
    // console.log("this.$route.query.type",this.$route.query.type)
    this.showTab = this.$route.query.type === 'rent' ? 'rent' : this.$route.query.type ==='newEstate'?'newestate':this.$route.query.type ==='estate'?'estate':'sale';
 },
  components: {
    // [Toast.name]: Toast,
    historyList,
    newList,
    estList
  },
  watch: {
    showTab () {
        const property=this.showTab === 'sale'?this.sellProperty:this.showTab === 'rent'?this.rentProperty:this.showTab === 'newestate'?this.newProperty:this.estProperty;
        property.pageIndex=1;
        property.list=[];
        property.loading=true;
        property.finished = false;
        this.onload(property);
    },
    immediate:true
  },
  methods: {
    // 导航返回按钮
    onClickLeft() {
      if (!this.showClear) {
        if (this.$route.query.url) {
          window.location.href = location.origin + this.$route.query.url;
        } else {
          this.$router.push('/');
        }
      }
    },

    // 下拉加载更多
    onload(property) {
      this.axios
        .post(this.pub.getApi().SearchCollection, {
          sourceType: this.showTab,
          pageIndex: property.pageIndex,
          pageCount: 15,
          isShowSourceInfo: true
        })
        .then(res => {
          if (res.data.code === 0 && res.data.result.data) {
            if (property.pageIndex === 1) {
              if (res.data.result.count === 0) {
                property.showNull = true;
                property.clearText = '';
                return;
              } else {
                // debugger
                if (this.isShowPage) {
                  this.$toast(this.lang.find + res.data.result.count + `${this.showTab=='estate'?this.lang.wuEst:this.lang.properties}`);
                }
                property.showNull = false;
                property.clearText = this.lang.clear;
              }
            }
            property.list = property.list.concat(res.data.result.data);
            property.pageIndex++;
            property.loading = false;
            if (property.list.length >= res.data.result.count) {
              property.finished = true;
            }
          }
        })
        .catch(err => {});
    },
    // 清空收藏弹窗
    onClear() {
      this.showClear = true;
    },
    beforeClose(action, done) {
      if (action === 'confirm') {
        this.clearCollection();
        done();
      } else {
        done();
      }
    },
    //删除收藏
    clearCollection() {
      this.axios
        .get(this.pub.getApi().DeleteCollection, {
          params: {
            sourceType:this.showTab
          }
        })
        .then(res => {
          if (res.data.code === 0) {
            const property=this.showTab==='sale'? this.sellProperty:this.showTab==='rent' ? this.rentProperty :this.showTab==='estate' ?this.estProperty :this.newProperty;
            property.list=[]
            property.showNull = true;
            property.clearText = '';
          }
        })
        .catch(err => {});
    },
    cancelCollection(id,index) {
        this.axios
          .get(
            this.pub.getApi().DeleteCollection,
            {
              params: {
                collectionId: id,
                sourceType: 'newEstate'
              }
            }
          )
          .then(res => {
            if (res.data.code === 0) {
              this.newProperty.list.splice(index,1);
              if(!this.newProperty.list.length){
                this.newProperty.showNull=true;
                this.newProperty.clearText="";
              }
            }
          })
    },
  }
};
</script>

<style scoped>
/* 导航 */
.col-header {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 44px;
  z-index: 4;
}
.col-header [class*='van-hairline']::after {
  border-bottom: 1px solid #e3e4e6;
}
.van-nav-bar {
  height: 44px;
  background-color: #fafbfc;
  border-bottom: 1px solid #e3e4e6;
}
.van-nav-bar__text {
  height: 44px;
  font-size: 15px;
  color: #333333;
  padding:0 12px;
}
.van-nav-bar .van-icon {
  color: #423f3f;
  font-size: 25px;
}
/* tab切换 */
/* .col-tab{
  display: flex;
  width: 100%;
  height: 30px;
  line-height: 30px;
}  */
.col-tab {
  display: flex;
  width:65%;
  height: 30px;
  line-height: 30px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 5;
  border-radius: 100px;
  overflow: hidden;
  box-sizing:border-box;
  border: 0.5px solid rgba(41, 38, 48, 0.32);
}
.col-tab span {
  flex:1;
  font-size: 12px;
  color: #333333;
  letter-spacing: 0.18px;
  background-color: #fafbfc;
}
/* .col-tab span:nth-child(2){
  box-sizing:border-box;
  border-left:0.5px solid rgba(41, 38, 48, 0.32);
  border-right:0.5px solid rgba(41, 38, 48, 0.32);
} */
.col-tab span:not(:first-child){
  box-sizing:border-box;
  border-left:0.5px solid rgba(41, 38, 48, 0.32);
  border-right:0.5px solid rgba(41, 38, 48, 0.32);
}
.col-tab .on {
  background-color: #333333;
  color: #ffffff;
}

/* 没有记录 */
.none-record {
  width: 100%;
  position: absolute;
  top: 44px;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: #f5f6f7;
}
.none-record p {
  margin: 0;
  font-size: 15px;
  color: #333333;
}
.none_col {
  width: 120px;
  height: 120px;
  margin: 82px auto 0;
}
/* 点击清除出现蒙版 */
.popup-clear {
  background-color: rgba(0, 0, 0, 0.35);
  width: 100%;
  height: 100vh;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 3;
}
</style>
